import {Samples} from "src/app/infrastructure/moovement-api/models/samples";
import {Observable} from "rxjs";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Injectable} from "@angular/core";

export interface RecordNfcLocationSamplesRequest {
  deviceId: string;
  values: Samples.SampleValue<Samples.NfcGpsFix>[];
  scannedAt: string;
  scanningDevice: string;
  discrepancyReason: string | null;
  failedScan: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AssetSampleApiClient extends MoovementApiClient {



  getAssetSamplesSince<T>(capability: string, assetIds: string[], since: Date): Observable<Samples.AssetSample<T>[]> {
    return this.httpClient.post<Samples.AssetSample<T>[]>(`${this.baseUrl}/api/sample/list/${capability}/${since.toISOString()}`, assetIds)
  }

  getAssetSamplesBetween<T>(capability: string, assetIds: string[], from: Date, to: Date): Observable<Samples.AssetSample<T>[]> {
    return this.httpClient.post<Samples.AssetSample<T>[]>(`${this.baseUrl}/api/sample/list/${capability}/${from.toISOString()}/${to.toISOString()}`, assetIds)
  }

  getLatestAssetSamples<T>(capability: string, assetIds: string[], since?: Date): Observable<Samples.AssetSample<T>[]> {
    if (since) {
      return this.httpClient.post<Samples.AssetSample<T>[]>(`${this.baseUrl}/api/sample/list/${capability}/latest?since=${since.toISOString()}`, assetIds)
    }
    return this.httpClient.post<Samples.AssetSample<T>[]>(`${this.baseUrl}/api/sample/list/${capability}/latest`, assetIds)
  }

  getAllAssetSamples<T>(capability: string, assetIds: string[]): Observable<Samples.AssetSample<T>[]> {
    return this.httpClient.post<Samples.AssetSample<T>[]>(`${this.baseUrl}/api/sample/list/${capability}`, assetIds)
  }

  recordNfcLocationSamples(request: RecordNfcLocationSamplesRequest): Observable<void> {
    return this.httpClient.post<void>(`${this.baseUrl}/api/sample/nfcLocation`, request);
  }

}
